import CustomerInsights from "./CustomerInsights";

export default CustomerInsights;
